import $ from 'jquery';
import GoogleMaps from 'google-maps';

GoogleMaps.KEY = 'AIzaSyAScl1EvYlHi3QucCZEfPFb-SFkuljAd_M';

const GREYSCALE_STYLES = [
  {
    featureType: 'all',
    elementType: 'all',
    stylers: [
      {
        saturation: -100,
      },
    ],
  },
];

const PIN = {
  width: 230,
  height: 59,
};

$(() => {
  const $googleMap = $('.js-google-map');
  if ($googleMap.length === 0) {
    return;
  }

  GoogleMaps.load((google) => {
    const accent = $('body').data('accent');
    const coords = new google.maps.LatLng(-37.798158, 144.986671);
    const element = $googleMap[0];
    const styles = $googleMap.data('greyscale') ? GREYSCALE_STYLES : undefined;

    const map = new google.maps.Map(element, {
      mapTypeControl: true,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      panControl: true,
      scaleControl: true,
      scrollwheel: false,
      streetViewControl: false,
      styles,
      zoom: 13,
      zoomControl: true,
    });

    const marker = new google.maps.Marker({
      position: coords,
      icon: {
        url: `/static/images/map-pin-${accent}.png`,
        size: new google.maps.Size(PIN.width, PIN.height),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(PIN.width / 2, PIN.height),
      },
    });
    marker.setMap(map);

    map.setCenter(coords);
  });
});



// WEBPACK FOOTER //
// ./_components/google-maps-block/index.js